import http from 'axios'

let finishFunction = response => {
    return response
};
let errorFunction = error => {
        if (error.response){
            if (error.response.status === 500) {
                this.$router.push({ 'name': '500' })
            }
        }
        return Promise.reject(error)
    };
    // http.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
    // Add a request interceptor
http.interceptors.request.use(function(config) {
    // loadFunction()
    //   if(oAuth.isAuthenticated()){
    //     config.headers['Authorization'] = oAuth.getAuthHeader() //Example: Bearer asf3132dfsfddffd
    //   }

    return config;
}, function(error) {
    // Do something with request error
    errorFunction();
    return Promise.reject(error);
});

// Add a response interceptor
http.interceptors.response.use(function(response) {
    // Do something with response data
    finishFunction();
    return response;
}, function(error) {
    // Do something with response error


    errorFunction(error);
    return Promise.reject(error);
});